import { t } from 'i18next';
import React from 'react';
import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
import { Card, Col, Row } from 'react-bootstrap';
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';

class ELEMENT_OBLIGATIONS_CONTROL extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dummyData: { 
        item: {
          n_cumplidas: 12,
          n_exigibles: 5,
          n_porvencer: 23,
          n_vencidas: 8
        }
      },
      series: [23, 8, 12, 55],
      options: {
        chart: {
          type: 'donut',
        },
        colors: ["#ECA700", "#f24656", "#25aa34", "#808080"],
        legend: {
          show: false,
        },
      }, 
    };
  }

  static propTypes = {
    inputParam_HideHeader: PropTypes.bool,
    inputParam_UseFake: PropTypes.bool,
    inputParam_ComponentContent: PropTypes.object,
  };

  static defaultProps = {
    inputParam_HideHeader: false,
    inputParam_UseFake: false,
    inputParam_ComponentContent: null,
  };

  renderContent(data) {
    return  <Row className='px-3 h-100'>
              <Col xl={8} className='pt-4 mt-4'>
                <ReactApexChart options={this.state.options} series={this.state.series} type="donut" height="85%" />
              </Col>
              <Col>
                <Row className='border-top border-end border-bottom my-1 h-23' style={{borderLeft: "10px solid #ECA700"}}>
                  <Col className='ms-1'>
                    <Row>
                      <Col style={{fontSize: "26px", fontWeight: "bold"}} className='px-0'>
                        { data !== null ? data.item.n_porvencer : '--' }
                      </Col>
                    </Row>
                    <Row>
                      <Col className='px-0'>
                        {t('data-lang-lbl-toexpire')}
                      </Col>
                    </Row>  
                  </Col>
                </Row>

                <Row className='border-top border-end border-bottom my-1 h-23' style={{borderLeft: "10px solid #f24656"}}>
                  <Col className='ms-1'>
                    <Row>
                      <Col style={{fontSize: "26px", fontWeight: "bold"}} className='px-0'>
                        { data !== null ? data.item.n_vencidas : '--' }
                      </Col>
                    </Row>
                    <Row>
                      <Col className='px-0'>
                        {t('data-lang-lbl-overdues')}
                      </Col>
                    </Row>  
                  </Col>
                </Row>

                <Row className='border-top border-end border-bottom my-1 h-23' style={{borderLeft: "10px solid #25aa34"}}>
                  <Col className='ms-1'>
                    <Row>
                      <Col style={{fontSize: "26px", fontWeight: "bold"}} className='px-0'>
                        { data !== null ? data.item.n_cumplidas : '--' }
                      </Col>
                    </Row>
                    <Row>
                      <Col className='px-0'>
                        {t('data-lang-lbl-accomplisheds')}
                      </Col>
                    </Row>  
                  </Col>
                </Row>

                <Row className='border-top border-end border-bottom my-1 h-23' style={{borderLeft: "10px solid #808080"}}>
                  <Col className='ms-1'>
                    <Row>
                      <Col style={{fontSize: "26px", fontWeight: "bold"}} className='px-0'>
                        { data !== null ? data.item.n_exigibles : '--' }
                      </Col>
                    </Row>
                    <Row>
                      <Col className='px-0'>
                        {t('data-lang-lbl-requireds')}
                      </Col>
                    </Row>  
                  </Col>
                </Row>
              </Col>
            </Row>
  }

  render() {
    return (
      <>
      {
        !this.props.inputParam_UseFake &&
        <Card className='h-100' style={{border: "1px solid red"}}>
          {
            !this.props.inputParam_HideHeader &&
            <Card.Header className="card-header-compact">
              <Card.Title className="d-flex justify-content-between">
                <b>{ (this.props.inputParam_ComponentContent !== null && this.props.inputParam_ComponentContent.boardComponentTitle) ?? t('data-lang-boxname-obligations')}</b>
                <div className='toolbar d-flex'>
                  <HEADER_TOOLBAR
                    inputParam_BoardStructure={this.props.inputParam_BoardStructure}
                    inputParam_Container={this.props.inputParam_Container}
                  />
                </div>
              </Card.Title>
            </Card.Header>
          }
          <Card.Body className='px-1 py-0 h-100'>
            {this.renderContent(this.props.inputParam_ComponentContent)}
          </Card.Body>
        </Card>
      }
      { this.props.inputParam_UseFake && this.renderContent(this.state.dummyData) }
      </>
    );
  }
}

export default ELEMENT_OBLIGATIONS_CONTROL;